import PropTypes from 'prop-types';
// @mui
import { TableRow, TableCell, TableHead } from '@mui/material';

// ----------------------------------------------------------------------

DecentralitzationListHead.propTypes = {
    order: PropTypes.oneOf(['asc', 'desc']),
    orderBy: PropTypes.string,
    rowCount: PropTypes.number,
    headLabel: PropTypes.array,
    numSelected: PropTypes.number,
    onRequestSort: PropTypes.func,
    onSelectAllClick: PropTypes.func,
};

export default function DecentralitzationListHead({ order, orderBy, headLabel, onRequestSort }) {
    return (
        <TableHead>
            <TableRow>
                <TableCell padding="checkbox"></TableCell>
                {headLabel.map((headCell, index) => (
                    <TableCell key={index}>
                        <TableHead>{headCell.label}</TableHead>
                    </TableCell>
                ))}
            </TableRow>
        </TableHead>
    );
}
